<template>
  <div>
    <b-card class="mb-2 custom-card-body">
      <b-card-text>
        <b-row class="mt-1">
         <b-col cols="10" class="mb-2">
              <span class="h3 text-primary font-weight-bolder text-uppercase mt-3 "> 
                <feather-icon
                      icon="UsersIcon"
                      class="mr-50"
                    size="20"
                    />
                     Mon contact Bubble-In  
                </span>          

              <span class="h3 font-weight-bolder d-block mt-2 ">Support Bubble-In</span>  
              <div  class="mt-1">
                <small class="text-muted d-block">
                    <span>Téléphone : +33 1.75.95.22.99</span>
                  
                </small>
                <div  class="mt-1 text-muted">
                <span >Email: </span> <a :style="isBoiteSync ? { 'text-decoration': 'underline', } : { 'text-decoration': 'initial', 'cursor': 'default' }" @click="showEmail('support@bubble-in.com')">support@bubble-in.com</a>
               </div>
              </div>
            </b-col>
        </b-row>

      </b-card-text>
    </b-card>
  </div>
</template>

<script>

import { BBadge, BButton, BCard, BCardText, BCol, BRow, VBToggle } from 'bootstrap-vue'


export default {
  components: {
    BBadge,
    BRow,
    BCol,
    BButton,
    BCard,
    BCardText,
    VBToggle,
   
},

  data(){
    return{
      isBoiteSync: false,
    }
  },

  created: function () {
        this.checkSyncBoiteEmail()
    },
  methods: {
        checkSyncBoiteEmail() {
            this.isBoitEmailSync().then(response => {
                if(response)
                this.isBoiteSync = true
                else this.isBoiteSync = false
            })
        },
        showEmail(email,copierCarbon = null) {
            if(this.isBoiteSync) {
            this.$router.push({
              name: 'messageries',
              params: {
                operation: 'send',
                email: email,
                copierCarbon
              }
            });
          }
        },

  }

}
   
</script>

<style >


</style>

